module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hQeq4"))).then(() => parcelRequire('hEqeo'));